import { ScrollReveal } from './ScrollReveal';
import { ShieldCheck, Lock, FileCheck, Globe, Server, Scale, Eye, KeyRound } from 'lucide-react';

const CERTIFICATIONS = [
  { icon: ShieldCheck, label: 'GDPR', title: 'GDPR Compliant', desc: 'Fully aligned with the General Data Protection Regulation for EU and UK data subjects.' },
  { icon: Lock, label: 'SOC 2', title: 'SOC 2 Type II', desc: 'Security, availability, and confidentiality controls audited and verified.' },
  { icon: FileCheck, label: 'ISO 27001', title: 'ISO 27001', desc: 'Information security management systems certified to international standards.' },
  { icon: Server, label: 'ISO 27701', title: 'ISO 27701', desc: 'Privacy information management extending ISO 27001 for data protection.' },
  { icon: Globe, label: 'UK DPA', title: 'UK Data Protection Act', desc: 'Compliant with the UK Data Protection Act 2018 and UK GDPR.' },
  { icon: Scale, label: 'AI Act', title: 'EU AI Act Ready', desc: 'Architecture designed for compliance with the EU Artificial Intelligence Act.' },
  { icon: Eye, label: 'Audit', title: 'Full Auditability', desc: 'Complete audit trails for all agent actions, decisions, and data interactions.' },
  { icon: KeyRound, label: 'Encryption', title: 'End-to-End Encryption', desc: 'Data encrypted in transit and at rest using industry-standard protocols.' },
];

export default function ComplianceBadges() {
  return (
    <section className="relative py-16 overflow-hidden" data-testid="compliance-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-10">
            <div className="overline mb-3">Compliance & Certifications</div>
            <h3 className="font-heading text-xl sm:text-2xl tracking-tight font-medium text-aurocle-text">
              Enterprise-grade standards.
            </h3>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
            {CERTIFICATIONS.map((cert, i) => {
              const Icon = cert.icon;
              return (
                <div key={i} className="group relative" data-testid={`cert-${cert.label.toLowerCase().replace(/\s/g, '-')}`}>
                  <div className="p-4 bg-aurocle-surface border border-white/5 hover:border-aurocle-gold/20 transition-all text-center cursor-default">
                    <Icon size={20} className="text-aurocle-gold/60 group-hover:text-aurocle-gold transition-colors mx-auto mb-2" />
                    <div className="text-[10px] font-mono text-aurocle-text uppercase tracking-wider">{cert.label}</div>
                  </div>
                  {/* Tooltip */}
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 p-3 bg-aurocle-elevated border border-aurocle-gold/15 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-20 shadow-xl">
                    <div className="text-xs font-heading text-aurocle-text font-medium mb-1">{cert.title}</div>
                    <div className="text-[10px] text-aurocle-platinum-muted leading-relaxed">{cert.desc}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <div className="mt-8 text-center">
            <p className="text-xs text-aurocle-text-secondary max-w-2xl mx-auto">
              Aurocle Agents is designed for deployment in regulated, high-governance environments. Our architecture supports compliance with international data protection regulations, security standards, and AI governance frameworks.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
